import { BaseEntity } from '@/api/EntityApi';
import { DeepKeys } from '@tanstack/react-table';
import LANGUAGES from '@/configs/languages';

export type Language = keyof typeof LANGUAGES;
export type ForeignLanguage = Exclude<Language, 'EN'>;
export type Translations<TData> = Record<ForeignLanguage, TData>;

export type SortOrder = 'ASC' | 'DESC';

export interface Sort<TData extends BaseEntity = any> {
	key: DeepKeys<TData> | null;
	order: SortOrder;
}

export interface ApiQueryOptions<TData extends BaseEntity> {
	page: number;
	limit: number;
	search: string;
	sortBy: Sort<TData>;
}

export type CustomFilters = Record<string, unknown>;

export interface ApiPaginatedResponse<TData extends {} = {}> {
	data: TData[];
	meta: {
		currentPage: number;
		itemsPerPage: number;
		totalItems: number;
		totalPages: number;
	};
}

export interface ApiFormattedResponseData<TData extends {} = {}> {
	data: TData[];
	totalPages: number;
}

export interface CreateManyResponse {
	passed: string[];
	rejected: string[];
}

export interface Attachment {
	id: UUID;
	path: string;
	name: string;
	size: number;
	mimetype: string;
	width: number;
	height: number;
}

export type UUID = ReturnType<typeof crypto.randomUUID>;

export interface Location {
	placeId: string;
	cityId: string;
	displayName: string;
	cityName: string;
	provinceName: string;
	formattedAddress: string;
	googleMapsUri: string;
}

export enum AppCurrency {
	BGN = 'bgn',
	CHF = 'chf',
	CZK = 'czk',
	DKK = 'dkk',
	EUR = 'eur',
	GBP = 'gbp',
	HUF = 'huf',
	ISK = 'isk',
	NOK = 'nok',
	PLN = 'pln',
	RON = 'ron',
	SEK = 'sek',
	USD = 'usd',
}

export const LOCALIZATION_TYPES = {
	PROVINCE: 'administrative_area_level_1',
	COUNTY: 'administrative_area_level_2',
	CITY: 'locality',
	ART_GALLERY: 'art_gallery',
	ART_MUSEUM: 'art_museum',
	ART_STUDIO: 'art_studio',
};
